import React from 'react';

const PrivacyPolicy = () => {
  const styles = {
    container: {
      backgroundColor: '#1A1A1A',
      color: 'white',
      padding: '2rem',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'Inter, system-ui, sans-serif',
      lineHeight: '1.6'
    },
    heading1: {
      fontSize: '2.5rem',
      marginBottom: '1rem'
    },
    heading2: {
      fontSize: '2rem',
      marginBottom: '1rem',
      marginTop: '2rem'
    },
    heading3: {
      fontSize: '1.5rem',
      marginBottom: '1rem',
      marginTop: '1.5rem'
    },
    heading4: {
      fontSize: '1.25rem',
      marginBottom: '0.5rem',
      marginTop: '1rem'
    },
    paragraph: {
      marginBottom: '1rem'
    },
    list: {
      marginLeft: '2rem',
      marginBottom: '1rem'
    },
    listItem: {
      marginBottom: '0.5rem'
    },
    link: {
      color: '#3B82F6',
      textDecoration: 'none'
    },
    section: {
      marginBottom: '2rem'
    },
    date: {
      color: '#9CA3AF',
      marginBottom: '2rem'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading1}>Privacy Policy</h1>
      <p style={styles.date}>Last updated: February 04, 2025</p>

      <p style={styles.paragraph}>
        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
      </p>

      <p style={styles.paragraph}>
        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
      </p>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Interpretation and Definitions</h2>
        
        <h3 style={styles.heading3}>Interpretation</h3>
        <p style={styles.paragraph}>
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>

        <h3 style={styles.heading3}>Definitions</h3>
        <p style={styles.paragraph}>For the purposes of this Privacy Policy:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
          <li style={styles.listItem}><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
          <li style={styles.listItem}><strong>Application</strong> refers to Step In Home Services, the software program provided by the Company.</li>
          <li style={styles.listItem}><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Step In Home Services, No. 40, Govinda Gopala Krupa, Dsouza Layout, Banashankari 3rd Stage, Hosakerehalli, Bengaluru, Karnataka 560085.</li>
          <li style={styles.listItem}><strong>Country</strong> refers to: Karnataka, India</li>
          <li style={styles.listItem}><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
          <li style={styles.listItem}><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
          <li style={styles.listItem}><strong>Service</strong> refers to the Application.</li>
          <li style={styles.listItem}><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
          <li style={styles.listItem}><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
          <li style={styles.listItem}><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Collecting and Using Your Personal Data</h2>
        <h3 style={styles.heading3}>Types of Data Collected</h3>
        
        <h4 style={styles.heading4}>Personal Data</h4>
        <p style={styles.paragraph}>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Email address</li>
          <li style={styles.listItem}>First name and last name</li>
          
        </ul>

        
       
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Use of Your Personal Data</h2>
        <p style={styles.paragraph}>The Company may use Personal Data for the following purposes:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>To provide and maintain our Service</strong>, whenever you contact us through our contact form</li>
    
          <li style={styles.listItem}><strong>To contact You</strong>: By email, telephone calls, SMS, or other equivalent forms of electronic communication.</li>
          
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Security of Your Personal Data</h2>
        <p style={styles.paragraph}>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Children&apos;s Privacy</h2>
        <p style={styles.paragraph}>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Changes to this Privacy Policy</h2>
        <p style={styles.paragraph}>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading2}>Contact Us</h2>
        <p style={styles.paragraph}>If you have any questions about this Privacy Policy, You can contact us:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>By email: info@stepinhomeservices.in</li>
          <li style={styles.listItem}>By visiting this page on our website: <a href="https://stepinhomeservices.in/" style={styles.link}>https://stepinhomeservices.in/</a></li>
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPolicy;